var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarouselArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 1.428l7.046 6.547-6.89 6.646 1.5 1.378L9 7.925.45-.001-1 1.428z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNLTEgMS40Mjc1OUw2LjA0NjI4IDcuOTc0OTlMLTAuODQzNzUgMTQuNjIwN0wwLjY1NjI2NSAxNS45OTlMOC45OTg3OCA3LjkyNDczTDAuNDUwMDQzIC0wLjAwMDk4MDM2MkwtMSAxLjQyNzU5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgCarouselArrow as ReactComponent };